import { usePublicBoundlessConfigRetrieveSuspense } from "@boundless/bl-api-client/public/services"
import { linkOptions } from "@tanstack/react-router"

/**
 * Resolves where "create an account" points, or `null` when signup is switched
 * off. Both cross-links to signup — the one in the mobile header and the one
 * under the sign-in heading — need the same config check and the same
 * slug-aware target, and only differ in how they render it.
 *
 * This reads a suspending query, so callers need a boundary above them.
 */
export function useSignupLink(slug?: string) {
  const { data: config } = usePublicBoundlessConfigRetrieveSuspense()

  if (!config.signupEnabled) {
    return null
  }

  return slug
    ? linkOptions({ to: "/p/$slug/signup", params: { slug } })
    : linkOptions({ to: "/signup" })
}
